// extracted by mini-css-extract-plugin
export default {"root":"PlainButton-module--root--61d80","childrenContainer":"PlainButton-module--childrenContainer--85137","disabled":"PlainButton-module--disabled--16e9c"};